import { ProjectsDataCollectionDocument } from 'generated/resources/graphql'

import BulkAssignProjectClientModal from 'modules/project_management/components/modals/BulkAssignProjectClientModal'

interface AssignClientModalProps {
  ids: number[]
  onCloseModal?: () => void
}

export const AssignClientModal = ({ ids, onCloseModal }: AssignClientModalProps) => {
  return (
    <BulkAssignProjectClientModal
      projectIds={ids}
      onClose={() => onCloseModal?.()}
      refetchQueries={[ProjectsDataCollectionDocument]}
    />
  )
}
